import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import "./datingapp.css";
import ServiceFooter from "../../ServiceFooter";
import { Navigation, A11y, Pagination, Controller } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useState } from "react";
import {
  aiImg,
  backendImg,
  cloudImg,
  databaseImg,
  frontendImg,
  securityImg,
  tech,
} from "./data";

const Datingapp = () => {
  const [isPrevChooseDisabled, setIsPrevChooseDisabled] = useState(true);
  const [isNextChooseDisabled, setIsNextChooseDisabled] = useState(false);

  const handleChooseChange = (chooseSwiper) => {
    setIsPrevChooseDisabled(chooseSwiper.isBeginning);
    setIsNextChooseDisabled(chooseSwiper.isEnd);
  };

  // key features
  const [isPrevKeyDisabled, setIsPrevKeyDisabled] = useState(true);
  const [isNextKeyDisabled, setIsNextKeyDisabled] = useState(false);

  const handleKeyChange = (keySwiper) => {
    setIsPrevKeyDisabled(keySwiper.isBeginning);
    setIsNextKeyDisabled(keySwiper.isEnd);
  };

  const [technology, setTechnology] = useState("Frontend");

  const handleTechnologyChange = (data) => {
    setTechnology(data);
  };

  // why choose
  const [isPrevWhyDisabled, setIsPrevWhyDisabled] = useState(true);
  const [isNextWhyDisabled, setIsNextWhyDisabled] = useState(false);

  const handleWhyChange = (WhySwiper) => {
    setIsPrevWhyDisabled(WhySwiper.isBeginning);
    setIsNextWhyDisabled(WhySwiper.isEnd);
  };

  // why choose
  const [isPrevFutureDisabled, setIsPrevFutureDisabled] = useState(true);
  const [isNextFutureDisabled, setIsNextFutureDisabled] = useState(false);

  const handleFutureChange = (FutureSwiper) => {
    setIsPrevFutureDisabled(FutureSwiper.isBeginning);
    setIsNextFutureDisabled(FutureSwiper.isEnd);
  };

  const [horizontalSwiper, setHorizontalSwiper] = useState(null);
  const [verticalSwiper, setVerticalSwiper] = useState(null);

  const [isPrevProcessDisabled, setIsPrevProcessDisabled] = useState(false);
  const [isNextProcessDisabled, setIsNextProcessDisabled] = useState(false);

  return (
    <>
      <header>
        <NewHead />
      </header>

      <Helmet>
        <title> Dating app development company</title>

        <meta name="title" content=" Dating app development company " />
        <meta
          name="description"
          content=" Develop your AI based feature rich Dating app with  beleaf technologies. Outsmart your competitors with the next generation dating app. Get free consultation"
        />

        <meta property="og:title" content=" Dating app development company" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/dating-app-development-company"
        />
      </Helmet>

      <main className="dt-main">
        {/* hero */}
        <article className="dt-hero primary__landing__container dt-mb-100">
          <div className="row mx-0 align-items-center dt-hero-row">
            <div className="col-lg-5 col-md-6 dt-hero-lft-col">
              <span className="dt-hero-title-span">AI Powered</span>
              <h1 className="dt-hero-title">
                <span className="dt-span">Dating App </span>
                Development Company
              </h1>
              <div className="dr-hero-btn-wrap">
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="primary-landing-main-btn re-hero-btn mt-lg-5 mt-4"
                >
                  <div className="re-btn-txt">Get Free Consultation</div>
                  <span className="mx-2 right-arr">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>
            <div className="col-lg-7 col-md-6">
              <img
                src={require("../../../image/Dating/hero.webp")}
                alt="Dating app development company"
              />
            </div>
          </div>
        </article>

        {/* build */}
        <article className="primary__landing-content-container dt-mb-100">
          <div className="row mx-0 dt-build-row">
            <div className="col-lg-6 dt-build-left-col">
              <img
                src={require("../../../image/Dating/build.webp")}
                alt="Dating app development company"
              />
            </div>
            <div className="col-lg-6">
              <h3 className="dt-subtitle">
                Build a Feature{" "}
                <span className="dt-span">Rich and Scalable Dating App</span>{" "}
                with Our Expertise
              </h3>
              <p className="dt-subcontent">
                Are you looking for a dating app development company that can
                bring your innovative matchmaking ideas to life? Our team of
                expert developers specializes in creating high-quality,
                scalable, and feature-rich dating apps that help users find
                meaningful connections. Whether you need a simple dating app or
                a complex AI-powered matchmaking solution, we deliver apps that
                drive engagement and success.
              </p>
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn re-hero-btn mt-4"
              >
                <div className="re-btn-txt">Get Free Demo</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </article>

        {/* why invest */}
        <div className="dt-inv-outer ">
          <article className="dt-invest primary__landing__container">
            <h3 className="dt-subtitle dt-invest-title">
              Why Invest in a <span className="dt-span"> Dating App</span>{" "}
              Development Company?
            </h3>
            <p className="dt-subcontent dt-invest-mw">
              The online dating industry is booming, with millions of users
              looking for meaningful relationships through dating apps. If you
              want to tap into this growing market, investing in dating app
              development can be a profitable decision. Here’s why
            </p>
            <div className="dt-inv-img-wrap">
              <img
                src={require("../../../image/Dating/invest.webp")}
                alt="Dating app development company"
                loading="lazy"
              />
            </div>
          </article>
          <article className="row dt-invest-row primary__landing__container dt-mb-100">
            <div className="col-lg-3 col-md-6 dt-inv-col col-one">
              <img
                src={require("../../../image/Dating/inv-one.webp")}
                alt="Dating app development company"
              />
              <h5>Growing Market Demand</h5>
              <p>
                The global online dating market is expected to reach $10 billion
                by 2030.
              </p>
            </div>
            <div className="col-lg-3 col-md-6 dt-inv-col col-two">
              <img
                src={require("../../../image/Dating/inv-two.webp")}
                alt="Dating app development company"
              />
              <h5>High User Engagement</h5>
              <p>
                Dating apps have a high retention rate and user interaction,
                making them lucrative.
              </p>
            </div>
            <div className="col-lg-3 col-md-6 dt-inv-col col-three">
              <img
                src={require("../../../image/Dating/inv-three.webp")}
                alt="Dating app development company"
              />
              <h5>Revenue Opportunities</h5>
              <p>
                Monetization options include premium subscriptions, ads, in-app
                purchases, and more.
              </p>
            </div>
            <div className="col-lg-3 col-md-6 dt-inv-col col-four">
              <img
                src={require("../../../image/Dating/inv-four.webp")}
                alt="Dating app development company"
              />
              <h5>Innovative Technologies</h5>
              <p>
                With AI-based matching, video chats, and secure payments, dating
                apps are evolving rapidly.
              </p>
            </div>
          </article>
          {/* evolution */}
          <article className="dt-mb-100 dt-ev-outer">
            <div className="primary__landing-content-container">
              <div className="row mx-0 dt-ev-row">
                <div className="col-lg-6">
                  <h3 className="dt-subtitle dt-ev-mw">
                    Evolution of <span className="dt-span">Dating App</span>{" "}
                    Development
                  </h3>
                </div>
                <div className="col-lg-6">
                  <p className="dt-ev-content">
                    Traditional dating apps relied on basic matchmaking
                    algorithms, but the future demands smarter, data-driven, and
                    interactive platforms. Dating app development companies are
                    now integrating advanced technologies such as artificial
                    intelligence (AI), blockchain, augmented reality (AR), and
                    virtual reality (VR) to enhance user experiences.
                  </p>
                </div>
              </div>
            </div>
          </article>
        </div>

        {/* services */}
        <article className="dt-services primary__landing__container dt-mb-100">
          <h3 className="dt-subtitle dt-sv-title-mw">
            Our Dating App Development <span className="dt-span">Services</span>{" "}
          </h3>

          <div>
            <Swiper
              className="dt-service-swiper"
              spaceBetween={30}
              slidesPerView={3}
              modules={[Navigation, A11y, Pagination]}
              pagination={{
                clickable: true,
              }}
              scrollbar={{ draggable: true }}
              navigation={{
                prevEl: ".agent-our-prev-arrow",
                nextEl: ".agent-our-next-arrow",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                  slidesPerGroup: 3,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                  slidesPerGroup: 3,
                },
              }}
              onSlideChange={handleChooseChange}
              onReachBeginning={() => setIsPrevChooseDisabled(true)}
              onReachEnd={() => setIsNextChooseDisabled(true)}
              onFromEdge={() => {
                setIsPrevChooseDisabled(false);
                setIsNextChooseDisabled(false);
              }}
            >
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-sv-card-outer">
                    <div className="dt-sv-card sv-one">
                      <span>1</span>
                      <h5>Custom Dating App Development</h5>
                      <p>
                        We develop tailor-made dating apps based on your unique
                        vision and business goals. From simple swipe-based
                        matchmaking apps to AI-driven compatibility solutions.
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-sv-card-outer">
                    <div className="dt-sv-card sv-two">
                      <span>2</span>
                      <h5>AI-Powered Matchmaking Solutions</h5>
                      <p>
                        Our AI-driven dating apps use machine learning and
                        behavioral analysis to enhance user experiences and
                        improve match accuracy.
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-sv-card-outer">
                    <div className="dt-sv-card sv-three">
                      <span>3</span>
                      <h5>Niche Based Dating Apps</h5>
                      <p>
                        We develop specialized dating apps catering to specific
                        user groups such as professionals, seniors, pet lovers,
                        or religious communities.
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-sv-card-outer">
                    <div className="dt-sv-card sv-four">
                      <span>4</span>
                      <h5>Location-Based Dating Apps</h5>
                      <p>
                        Our team integrates GPS-based matchmaking to connect
                        users with potential matches nearby.
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-sv-card-outer">
                    <div className="dt-sv-card sv-five">
                      <span>5</span>
                      <h5>Video Dating App Development</h5>
                      <p>
                        We integrate real-time video calling and chat features
                        to improve interaction and engagement.
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-sv-card-outer">
                    <div className="dt-sv-card sv-six">
                      <span>6</span>
                      <h5>Secure & Scalable Architecture</h5>
                      <p>
                        Security is our top priority. We implement end-to-end
                        encryption, two-factor authentication, and other
                        security measures to ensure a safe dating experience.
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="fr-key-btn-wrapper">
              <button
                className={`agent-our-prev-arrow ${
                  isPrevChooseDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevChooseDisabled ? "#f539399c" : "#f53939",
                  cursor: isPrevChooseDisabled ? "not-allowed" : "pointer",
                  background: isPrevChooseDisabled
                    ? "transparent"
                    : "transparent",
                  border: "1px solid #0e0e1033",
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                className={`agent-our-next-arrow ${
                  isNextChooseDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextChooseDisabled ? "#1ea65773" : "#1ea657",
                  cursor: isNextChooseDisabled ? "not-allowed" : "pointer",
                  background: isNextChooseDisabled
                    ? "transparent"
                    : "transparent",
                  border: "1px solid #0e0e1033",
                }}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>

          <img
            src={require("../../../image/Dating/sv-line.webp")}
            alt="Dating app development company"
            className="sv-line-img"
          />
          <img
            src={require("../../../image/Dating/sv-line-two.webp")}
            alt="Dating app development company"
            className="sv-line-img-two"
          />
        </article>

        {/* key features */}
        <article className="dt-key primary__landing__container dt-mb-100">
          <h3 className="dt-subtitle dt-key-mw">
            <span className="dt-span">Key Features</span> of Our Dating Apps
          </h3>

          <div>
            <Swiper
              className="dt-service-swiper"
              spaceBetween={30}
              slidesPerView={3}
              modules={[Navigation, A11y, Pagination]}
              pagination={{
                clickable: true,
              }}
              scrollbar={{ draggable: true }}
              navigation={{
                prevEl: ".dt-prev-arrow",
                nextEl: ".dt-next-arrow",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                  slidesPerGroup: 3,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
              onSlideChange={handleKeyChange}
              onReachBeginning={() => setIsPrevKeyDisabled(true)}
              onReachEnd={() => setIsNextKeyDisabled(true)}
              onFromEdge={() => {
                setIsPrevKeyDisabled(false);
                setIsNextKeyDisabled(false);
              }}
            >
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-key-card">
                    <img
                      src={require("../../../image/Dating/key-img-one.webp")}
                      alt="Dating app development company"
                      className="w-100"
                      loading="lazy"
                    />
                    <h4>User Profiles & Authentication</h4>
                    <ul>
                      <li>Easy sign-up with email, phone, or social media</li>
                      <li>Profile verification for authenticity</li>
                      <li>
                        Customizable user profiles with photos, bio, and
                        interests
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-key-card">
                    <img
                      src={require("../../../image/Dating/key-img-two.webp")}
                      alt="Dating app development company"
                      className="w-100"
                      loading="lazy"
                    />
                    <h4>AI-Based Matching & Recommendations</h4>
                    <ul>
                      <li>Smart algorithms for better match suggestions</li>
                      <li>
                        Behavioral analysis and preference-based matchmaking
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-key-card">
                    <img
                      src={require("../../../image/Dating/key-img-three.webp")}
                      alt="Dating app development company"
                      className="w-100"
                      loading="lazy"
                    />
                    <h4>Swipe, Like & Match</h4>
                    <ul>
                      <li>Interactive swipe feature for quick matchmaking</li>
                      <li>Mutual likes to initiate conversations</li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-key-card">
                    <img
                      src={require("../../../image/Dating/key-img-four.webp")}
                      alt="Dating app development company"
                      className="w-100"
                      loading="lazy"
                    />
                    <h4>Chat & Messaging System</h4>
                    <ul>
                      <li>Real-time text and multimedia messaging</li>
                      <li>Voice and video calling features</li>
                      <li>
                        GIFs, stickers, and emojis for enhanced user experience
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-key-card">
                    <img
                      src={require("../../../image/Dating/key-img-five.webp")}
                      alt="Dating app development company"
                      className="w-100"
                      loading="lazy"
                    />
                    <h4>Geolocation & Proximity Matching</h4>
                    <ul>
                      <li>GPS-based matchmaking to find nearby users</li>
                      <li>
                        Location-based push notifications for nearby matches
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-key-card">
                    <img
                      src={require("../../../image/Dating/key-img-six.webp")}
                      alt="Dating app development company"
                      className="w-100"
                      loading="lazy"
                    />
                    <h4>Premium Membership & Monetization</h4>
                    <ul>
                      <li>Subscription plans for premium features</li>
                      <li>In-app purchases and virtual gifts</li>
                      <li>Advertisement integration</li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-key-card">
                    <img
                      src={require("../../../image/Dating/key-img-seven.webp")}
                      alt="Dating app development company"
                      className="w-100"
                      loading="lazy"
                    />
                    <h4>AI-Powered Safety Features</h4>
                    <ul>
                      <li>Profile verification and fraud detection</li>
                      <li>AI moderation for inappropriate content</li>
                      <li>Reporting and blocking features</li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="fr-key-btn-wrapper">
              <button
                className={`dt-prev-arrow ${
                  isPrevKeyDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevKeyDisabled ? "#f539399c" : "#f53939",
                  cursor: isPrevKeyDisabled ? "not-allowed" : "pointer",
                  background: isPrevKeyDisabled ? "transparent" : "transparent",
                  border: "1px solid #0e0e1033",
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                className={`dt-next-arrow ${
                  isNextKeyDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextKeyDisabled ? "#1ea65773" : "#1ea657",
                  cursor: isNextKeyDisabled ? "not-allowed" : "pointer",
                  background: isNextKeyDisabled ? "transparent" : "transparent",
                  border: "1px solid #0e0e1033",
                }}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </article>

        {/* technology */}
        <article className="dt-tech primary__landing__container dt-mb-100">
          <h3 className="dt-subtitle dt-tech-mw">
            Technologies <span className="dt-span">We Use for</span> Dating App
            Development
          </h3>
          <p className="dt-tech-content">
            We use the latest technologies and frameworks to ensure smooth
            performance, security, and scalability
          </p>

          <div className="dt-tech-tab-wrap">
            {/* tabs */}
            <div className="dt-tech-tab-head">
              {tech.map((tech) => {
                return (
                  <span
                    key={tech.id}
                    className={`dt-th-tb-title ${
                      technology === tech.title ? "active" : ""
                    }`}
                    onClick={() => handleTechnologyChange(tech.title)}
                  >
                    {tech.title}
                  </span>
                );
              })}
            </div>

            <div className="dt-tech-tab-body">
              {/* frontend */}
              {technology === "Frontend" && (
                <div className="dt-tech-tb-wrap">
                  {frontendImg.map((img) => {
                    return (
                      <div
                        key={img.id}
                        className="dt-fr-outer"
                        style={{
                          borderColor: img.borderClr,
                          borderWidth: "1px",
                          borderStyle: "solid",
                        }}
                      >
                        <div
                          className="dt-fr-inner"
                          style={{ backgroundColor: img.bgClr }}
                        >
                          <img
                            src={img.img}
                            alt="Dating app development company"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              {/* backend */}
              {technology === "Backend" && (
                <div className="dt-tech-tb-wrap">
                  {backendImg.map((img) => {
                    return (
                      <div
                        key={img.id}
                        className="dt-fr-outer"
                        style={{
                          borderColor: img.borderClr,
                          borderWidth: "1px",
                          borderStyle: "solid",
                        }}
                      >
                        <div
                          className="dt-fr-inner"
                          style={{ backgroundColor: img.bgClr }}
                        >
                          <img
                            src={img.img}
                            alt="Dating app development company"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              {/* database */}
              {technology === "Database" && (
                <div className="dt-tech-tb-wrap">
                  {databaseImg.map((img) => {
                    return (
                      <div
                        key={img.id}
                        className="dt-fr-outer"
                        style={{
                          borderColor: img.borderClr,
                          borderWidth: "1px",
                          borderStyle: "solid",
                        }}
                      >
                        <div
                          className="dt-fr-inner"
                          style={{ backgroundColor: img.bgClr }}
                        >
                          <img
                            src={img.img}
                            alt="Dating app development company"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              {/* AI & ML */}
              {technology === "AI & ML" && (
                <div className="dt-tech-tb-wrap">
                  {aiImg.map((img) => {
                    return (
                      <div
                        key={img.id}
                        className="dt-fr-outer"
                        style={{
                          borderColor: img.borderClr,
                          borderWidth: "1px",
                          borderStyle: "solid",
                        }}
                      >
                        <div
                          className="dt-fr-inner"
                          style={{ backgroundColor: img.bgClr }}
                        >
                          <img
                            src={img.img}
                            alt="Dating app development company"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              {/* security */}
              {technology === "Security" && (
                <div className="dt-tech-tb-wrap">
                  {securityImg.map((img) => {
                    return (
                      <div
                        key={img.id}
                        className="dt-fr-outer"
                        style={{
                          borderColor: img.borderClr,
                          borderWidth: "1px",
                          borderStyle: "solid",
                        }}
                      >
                        <div
                          className="dt-fr-inner"
                          style={{ backgroundColor: img.bgClr }}
                        >
                          <img
                            src={img.img}
                            alt="Dating app development company"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              {/* cloud */}
              {technology === "Cloud Services" && (
                <div className="dt-tech-tb-wrap">
                  {cloudImg.map((img) => {
                    return (
                      <div
                        key={img.id}
                        className="dt-fr-outer"
                        style={{
                          borderColor: img.borderClr,
                          borderWidth: "1px",
                          borderStyle: "solid",
                        }}
                      >
                        <div
                          className="dt-fr-inner"
                          style={{ backgroundColor: img.bgClr }}
                        >
                          <img
                            src={img.img}
                            alt="Dating app development company"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </article>

        {/* process */}
        <article className="dt-mb-100">
          <div className="primary__landing__container">
            <h3 className="dt-subtitle dt-process-title">
              Our Dating App Development{" "}
              <span className="dt-span">Process</span>{" "}
            </h3>
          </div>

          <div className="row mx-0 dt-process-row">
            <div className="col-lg-6">
              {" "}
              <Swiper
                className="dt-service-swiper dt-process-swiper"
                slidesPerView={3}
                modules={[Navigation, A11y, Pagination, Controller]}
                pagination={{ clickable: true }}
                centeredSlides={true}
                initialSlide={5}
                autoHeight={true} // Ensures dynamic height
                navigation={{
                  prevEl: ".dt-pr-prev-arrow",
                  nextEl: ".dt-pr-nxt-arrow",
                }}
                controller={{ control: verticalSwiper }} // Sync with right-side Swiper
                onSwiper={setHorizontalSwiper} // Store Swiper instance
                breakpoints={{
                  320: { slidesPerView: 1, spaceBetween: 10 },
                  480: { slidesPerView: 1, spaceBetween: 20 },
                  768: { slidesPerView: 2, spaceBetween: 40 },
                  1025: { slidesPerView: 3, spaceBetween: 40 },
                  1200: { slidesPerView: 3, spaceBetween: 40 },
                }}
                onSlideChange={() => {
                  setIsPrevProcessDisabled(horizontalSwiper?.isBeginning);
                  setIsNextProcessDisabled(horizontalSwiper?.isEnd);
                }}
              >
                <SwiperSlide>
                  <div className="dt-process-card">
                    <img
                      src={require("../../../image/Dating/process-img-six.webp")}
                      alt="Dating app development company"
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dt-process-card">
                    <img
                      src={require("../../../image/Dating/process-img-five.webp")}
                      alt="Dating app development company"
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dt-process-card">
                    <img
                      src={require("../../../image/Dating/process-img-four.webp")}
                      alt="Dating app development company"
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dt-process-card">
                    <img
                      src={require("../../../image/Dating/process-img-three.webp")}
                      alt="Dating app development company"
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dt-process-card">
                    <img
                      src={require("../../../image/Dating/process-img-two.webp")}
                      alt="Dating app development company"
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dt-process-card">
                    <img
                      src={require("../../../image/Dating/process-img-one.webp")}
                      alt="Dating app development company"
                    />
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
            <div className="col-lg-6">
              <Swiper
                direction="vertical"
                modules={[Controller]}
                className="dt-process-text-swiper"
                slidesPerView={1}
                // initialSlide={5}
                controller={{ control: horizontalSwiper }} // Sync with left Swiper
                onSwiper={setVerticalSwiper} // Store Swiper instance
                reverseDirection={true}
              >
                <SwiperSlide>
                  <div className="dt-process-right">
                    <span>6</span>
                    <h5>Post-Launch Support & Maintenance</h5>
                    <p>
                      Our team provides ongoing support, updates, and
                      performance enhancements to keep your app competitive.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dt-process-right">
                    <span>5</span>
                    <h5>Deployment & Launch</h5>
                    <p>
                      We assist with launching your app on Google Play Store,
                      Apple App Store, and other platforms.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dt-process-right">
                    <span>4</span>
                    <h5>Testing & Quality Assurance</h5>
                    <p>
                      Our rigorous testing process ensures bug-free performance,
                      security, and seamless user experience.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dt-process-right">
                    <span>3</span>
                    <h5> Development & Integration</h5>
                    <p>
                      We build the app using the latest technologies,
                      integrating essential features, AI-based algorithms, and
                      security measures.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dt-process-right">
                    <span>2</span>
                    <h5>UI/UX Design</h5>
                    <p>
                      Our team designs an engaging, user-friendly interface that
                      enhances user experience and interaction.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dt-process-right">
                    <span>1</span>
                    <h5> Requirement Analysis</h5>
                    <p>
                      We start with a thorough discussion to understand your
                      business goals, target audience, and app features.
                    </p>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>

            <div
              className="
            fr-key-btn-wrapper"
            >
              <button
                className={`dt-pr-nxt-arrow ${
                  isNextProcessDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevProcessDisabled ? "#f53939" : "#f53939",
                  background: isNextProcessDisabled
                    ? "transparent"
                    : "transparent",
                  border: "1px solid #0e0e1033",
                }}
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
              <div className="dt-process-heart">
                <i
                  className="fa-solid fa-heart"
                  style={{ color: "#ffffff" }}
                ></i>
              </div>
              <button
                className={`dt-pr-prev-arrow ${
                  isPrevProcessDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextProcessDisabled ? "#1ea657" : "#1ea657",
                  background: isPrevProcessDisabled
                    ? "transparent"
                    : "transparent",
                  border: "1px solid #0e0e1033",
                }}
              >
                <i className="fa-solid fa-check"></i>
              </button>
            </div>
          </div>
        </article>

        {/* why choose */}
        <article className="dt-choose primary__landing__container dt-mb-100">
          <h3 className="dt-subtitle dt-choose-mw">
            Why <span className="dt-span"> Choose Beleaf</span> as Your Dating
            App Development Company?
          </h3>

          <div>
            <Swiper
              className="dt-service-swiper dr-choose-swiper"
              spaceBetween={30}
              slidesPerView={3}
              modules={[Navigation, A11y, Pagination]}
              pagination={{
                clickable: true,
              }}
              scrollbar={{ draggable: true }}
              navigation={{
                prevEl: ".dt-ch-prev-arr",
                nextEl: ".dt-ch-next-arr",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                  slidesPerGroup: 3,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
              onSlideChange={handleWhyChange}
              onReachBeginning={() => setIsPrevWhyDisabled(true)}
              onReachEnd={() => setIsNextWhyDisabled(true)}
              onFromEdge={() => {
                setIsPrevWhyDisabled(false);
                setIsNextWhyDisabled(false);
              }}
            >
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-choose-cards dt-ch-one">
                    <img
                      src={require("../../../image/Dating/choose-img-one.webp")}
                      alt="Dating app development company"
                      className="dt-ch-img-one"
                    />
                    <span>1</span>
                    <h5>Expertise in Dating App Development</h5>
                    <p>
                      With years of experience, we understand the nuances of
                      dating platforms and deliver solutions that attract and
                      retain users.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-choose-cards dt-ch-two">
                    <span>2</span>
                    <h5>Custom & Scalable Solutions</h5>
                    <p>
                      We tailor the app to your business requirements, ensuring
                      flexibility and future scalability.
                    </p>
                    <img
                      src={require("../../../image/Dating/choose-img-two.webp")}
                      alt="Dating app development company"
                      className="dt-ch-img-two"
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-choose-cards dt-ch-three">
                    <img
                      src={require("../../../image/Dating/choose-img-three.webp")}
                      alt="Dating app development company"
                      className="dt-ch-img-three"
                    />
                    <span>3</span>
                    <h5>Cutting-Edge Technology</h5>
                    <p>
                      Our team integrates AI, blockchain, geolocation, and other
                      advanced technologies to enhance the user experience.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-choose-cards dt-ch-four">
                    <img
                      src={require("../../../image/Dating/choose-img-four.webp")}
                      alt="Dating app development company"
                      className="dt-ch-img-four"
                    />
                    <span>4</span>
                    <h5>Security & Privacy Compliance</h5>
                    <p>
                      We prioritize user safety with GDPR compliance,
                      encryption, and identity verification features.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-choose-cards dt-ch-five">
                    <span>5</span>
                    <h5>24/7 Technical Support</h5>
                    <p>
                      We provide ongoing maintenance and support to ensure
                      seamless app performance.
                    </p>
                    <img
                      src={require("../../../image/Dating/choose-img-five.webp")}
                      alt="Dating app development company"
                      className="dt-ch-img-five"
                    />
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="fr-key-btn-wrapper">
              <button
                className={`dt-ch-prev-arr ${
                  isPrevWhyDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevWhyDisabled ? "#0e0e1069" : "#0e0e10",
                  cursor: isPrevWhyDisabled ? "not-allowed" : "pointer",
                  background: isPrevWhyDisabled ? "transparent" : "transparent",
                  border: "1px solid #0e0e1033",
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                className={`dt-ch-next-arr ${
                  isNextWhyDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextWhyDisabled ? "#0e0e1069" : "#0e0e10",
                  cursor: isNextWhyDisabled ? "not-allowed" : "pointer",
                  background: isNextWhyDisabled ? "transparent" : "transparent",
                  border: "1px solid #0e0e1033",
                }}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </article>

        {/* monetize */}
        <div className="dt-monetize-outer ">
          <article className="dt-invest primary__landing__container dt-monetize">
            <h3 className="dt-subtitle dt-invest-title">
              Monetization<span className="dt-span"> Strategies</span> for
              Dating Apps
            </h3>

            <div className="dt-monetize-img-wrap">
              <img
                src={require("../../../image/Dating/monetize.webp")}
                alt="Dating app development company"
                // className="w-100"
              />
            </div>
          </article>
          <article className="row dt-invest-row primary__landing__container dt-mb-100">
            <div className="col-lg-3 col-md-6 dt-inv-col col-one">
              <img
                src={require("../../../image/Dating/mon-img-one.webp")}
                alt="Dating app development company"
              />
              <h5>Subscription Plans</h5>
              <p>
                Offer premium memberships with exclusive features like unlimited
                swipes, priority matching, and ad-free browsing.
              </p>
            </div>
            <div className="col-lg-3 col-md-6 dt-inv-col col-two">
              <img
                src={require("../../../image/Dating/mon-img-two.webp")}
                alt="Dating app development company"
              />
              <h5>In-App Purchases</h5>
              <p>
                Allow users to buy virtual gifts, premium profiles, or
                visibility boosts.
              </p>
            </div>
            <div className="col-lg-3 col-md-6 dt-inv-col col-three">
              <img
                src={require("../../../image/Dating/mon-img-three.webp")}
                alt="Dating app development company"
              />
              <h5>Advertisements </h5>
              <p>
                Integrate ad placements for third-party promotions or brand
                collaborations.
              </p>
            </div>
            <div className="col-lg-3 col-md-6 dt-inv-col col-four">
              <img
                src={require("../../../image/Dating/mon-img-four.webp")}
                alt="Dating app development company"
              />
              <h5>Affiliate Marketing</h5>
              <p>
                Earn commissions by promoting other services like restaurants,
                travel agencies, or lifestyle brands.
              </p>
            </div>
          </article>
        </div>

        {/* future trends */}
        <article className="dt-services primary__landing__container dt-mb-100">
          <h3 className="dt-subtitle dt-sv-title-mw">
            Future <span className="dt-span">Trends in</span> Dating App
            Development
          </h3>

          <p className="dt-subcontent dt-future-content">
            The dating app industry is constantly evolving. Here are some future
            trends that will shape the market
          </p>

          <div>
            <Swiper
              className="dt-service-swiper"
              spaceBetween={30}
              slidesPerView={3}
              modules={[Navigation, A11y, Pagination]}
              pagination={{
                clickable: true,
              }}
              scrollbar={{ draggable: true }}
              navigation={{
                prevEl: ".dt-ft-prev-arr",
                nextEl: ".dt-ft-next-arr",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                  slidesPerGroup: 3,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                  slidesPerGroup: 3,
                },
              }}
              onSlideChange={handleFutureChange}
              onReachBeginning={() => setIsPrevFutureDisabled(true)}
              onReachEnd={() => setIsNextFutureDisabled(true)}
              onFromEdge={() => {
                setIsPrevFutureDisabled(false);
                setIsNextFutureDisabled(false);
              }}
            >
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-sv-card-outer">
                    <div className="dt-sv-card sv-one">
                      <span>1</span>
                      <h5>AI & ML-Based Matchmaking</h5>
                      <p>
                        Smart algorithms that learn user behavior and
                        preferences
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-sv-card-outer">
                    <div className="dt-sv-card sv-two">
                      <span>2</span>
                      <h5>VR & AR Dating Experiences</h5>
                      <p>
                        Virtual reality-powered dates for enhanced user
                        engagement
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-sv-card-outer">
                    <div className="dt-sv-card sv-three">
                      <span>3</span>
                      <h5>Metaverse Dating Platforms</h5>
                      <p>
                        Metaverse-based dating app development will enable users
                        to interact in virtual spaces, creating a new era of
                        online dating.
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-sv-card-outer">
                    <div className="dt-sv-card sv-four">
                      <span>4</span>
                      <h5>Blockchain for Enhanced Security</h5>
                      <p>
                        Decentralized identity verification to prevent fraud
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-sv-card-outer">
                    <div className="dt-sv-card sv-five">
                      <span>5</span>
                      <h5>Voice & Video-Based Matchmaking</h5>
                      <p>AI-driven voice analysis for better matchmaking</p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="dt-sv-card-outer">
                    <div className="dt-sv-card sv-six">
                      <span>6</span>
                      <h5>Emotion Recognition Technology</h5>
                      <p>
                        AI will analyze user emotions through voice and text
                        inputs to suggest compatible matches with higher
                        emotional resonance.
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="fr-key-btn-wrapper">
              <button
                className={`dt-ft-prev-arr ${
                  isPrevFutureDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevFutureDisabled ? "#f539399c" : "#f53939",
                  cursor: isPrevFutureDisabled ? "not-allowed" : "pointer",
                  background: isPrevFutureDisabled
                    ? "transparent"
                    : "transparent",
                  border: "1px solid #0e0e1033",
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                className={`dt-ft-next-arr ${
                  isNextFutureDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextFutureDisabled ? "#1ea65773" : "#1ea657",
                  cursor: isNextFutureDisabled ? "not-allowed" : "pointer",
                  background: isNextFutureDisabled
                    ? "transparent"
                    : "transparent",
                  border: "1px solid #0e0e1033",
                }}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>

          <img
            src={require("../../../image/Dating/sv-line.webp")}
            alt="Dating app development company"
            className="sv-line-img"
          />
          <img
            src={require("../../../image/Dating/sv-line-two.webp")}
            alt="Dating app development company"
            className="sv-line-img-two"
          />
        </article>

        {/* Get Started*/}
        <div className="rs-mt-100 custom-get-in-touch ply-ta">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title dt-get-title">
              Get Started with Your Dating App Today
            </h5>
            <p className="custom-get-content dt-get-content">
              Are you ready to launch a successful dating app? Our dating app
              development company offers top-notch solutions tailored to your
              needs. With the right strategy, features, and cutting-edge
              technology, the future of online dating holds limitless
              possibilities. If you’re ready to build the next-generation dating
              platform, now is the time to invest in futuristic dating app
              development!  Whether you’re an entrepreneur, a startup, or an
              established business, we bring your dating app vision to reality.
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-4 re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          What is dating app development?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Dating app development is the process of building
                          mobile or web applications that facilitate online
                          matchmaking through AI, AR, and blockchain
                          integration.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          How much does it cost to develop a dating app?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The cost of dating app development varies based on
                          features and complexity, typically ranging from $5,000
                          to $50,000.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          What will be the time frame to develop a dating app?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          A dating app development company may take 3 to 12
                          months to complete a dating app, depending on the
                          project scope.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq4"
                        >
                          What features should a modern dating app have?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          A dating app should include AI matchmaking, video
                          chats, blockchain verification, AR/VR dating, and
                          social media integration.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead5">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq5"
                          aria-expanded="true"
                          aria-controls="faq5"
                        >
                          Why should I hire a professional dating app
                          development company?
                        </div>
                      </div>

                      <div
                        id="faq5"
                        className="collapse"
                        aria-labelledby="faqhead5"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          A professional dating app development company ensures
                          high-quality, scalable, and feature-rich apps with
                          advanced AI matchmaking and security capabilities.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default Datingapp;
